import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { RefreshIcon } from 'Asset/icon';
import { TextBold, TextMedium, TextSemiBold } from 'UiKit/typography';
import ButtonOutline from 'UiKit/button/buttonOutline';
import useGetGenerateSchedule from 'Domain/schedule-generate/useGetGenerateSchedule';

import styles from './styles.module.css';
import { useScheduleGenerateState } from 'View/schedule-generate/state';

const GenerateResultHead = () => {
  const { t } = useTranslation('schedule-generate');
  const { formData, updateState } = useScheduleGenerateState();
  const { mutate } = useGetGenerateSchedule();

  return (
    <>
      <Box>
        <TextBold className={styles['generate-result__text--title']}>{t('title')}</TextBold>
        <Box className={styles['generate-result__container--subtitle']}>
          <TextMedium className={styles['generate-result__text--subtitle']}>
            {t('manageGeneratedSchedule')}{' '}
            <span className={styles['generate-result__text--subtitle-link']} onClick={() => updateState({ openTutorialModal: true })}>
              {t('subtitleLinkText')}
            </span>
          </TextMedium>
        </Box>
      </Box>
      <ButtonOutline leftIcon={<RefreshIcon width="14px" height="14px" color="var(--color-info70)" />} onClick={() => mutate(formData)}>
        <TextSemiBold className={styles['generate-result__text--button-generate']}>{t('regenerateSchedule')}</TextSemiBold>
      </ButtonOutline>
    </>
  );
};

export default GenerateResultHead;
